module.exports = require("D:\\Projects\\Gatsby\\simple-adrianmanduc.com\\src\\utils\\typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 804
// module chunks = 231608221292675